import React from 'react'
import { Box, Container, withStyles, makeStyles, createStyles, Theme } from '@material-ui/core'
import { ArrowForward } from '@material-ui/icons'
import { ButtonLarge, StandardText } from '@rse/uikit'
import { LoginNav, SignUpNav } from '../../common/constants/routes'
import DoorAjar from './assets/DoorAjar'
import { ReactComponent as LogoLight } from '@rse/uikit/lib/icons/logo-light.svg'
import { Link, useHistory } from 'react-router-dom'
import { TextContent } from '../../common/textContent'

const useStyles = makeStyles(({ palette }: Theme) =>
  createStyles({
    containedSecondary: {
      backgroundColor: '#6B2EF5',
      color: palette.common.white,
    },
    iconStyle: {
      width: '100%',
      height: 'auto',
    },
    pageRoot: {
      '& .crisp-client': {
        display: 'none',
      },
    },
  })
)

export default function index() {
  const { containedSecondary, iconStyle } = useStyles()
  const history = useHistory()

  const redirectToSignUp = () => {
    history.push(SignUpNav.path)
  }

  return (
    <PageContainer>
      <Container maxWidth="xs">
          <CenteredRow>
            <LogoLight className={iconStyle} />
          </CenteredRow>
          <CenteredRow>
            <Box flexGrow={1} pt={1} pr={1}>
              <ButtonLarge
                endIcon={<ArrowForward />}
                onClick={redirectToSignUp}
                fullWidth
                className={containedSecondary}
              >
                <TextContent resourceKey="landing.join-movement" defaultValue="Join the Move-ment" />
              </ButtonLarge>
              <Box textAlign="center" color="#6B2EF5" pt={1}>
                <StandardText>
                  Already a member? <Link to={LoginNav.path}>Log in &gt;</Link>
                </StandardText>
              </Box>
            </Box>
            <DoorAjar />
          </CenteredRow>
      </Container>
    </PageContainer>
  )
}

const containerStyles = ({ palette }: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      width: '100vw',
      height: '100vh',
      alignItems: 'center',
      backgroundColor: palette.common.white,
    },
  })

const rowStyles = ({ spacing }: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: spacing(2),
      marginLeft: spacing(1),
      marginRight: spacing(1),
    },
  })

const PageContainer = withStyles(containerStyles)(Box)

const CenteredRow = withStyles(rowStyles)(Box)
